import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { LocalStorageService } from '../services/local-storage.service';
import { E_ThemeOption } from '../enums/themes.enum';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private storage = inject(LocalStorageService);
  private currentTheme: BehaviorSubject<E_ThemeOption> = new BehaviorSubject<E_ThemeOption>(E_ThemeOption.Dark);

  constructor() {
    const localTheme = this.storage.getItem('preferredTheme') as E_ThemeOption;
    // Inicializar el estado antes de configurar el listener
    this.setTheme(localTheme || E_ThemeOption.System);
    
    this.initSystemListener();
  }

  private initSystemListener() {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    
    mediaQuery.addEventListener('change', () => {
      // Solo aplicar el cambio si el usuario tiene seleccionada la opción 'System'
      if (this.currentTheme.getValue() === E_ThemeOption.System) {
        this.applyTheme(E_ThemeOption.System);
      }
    });
  }

  getTheme(): Observable<E_ThemeOption> {
    return this.currentTheme.asObservable();
  }

  setTheme(theme: E_ThemeOption) {
    this.storage.setItem('preferredTheme', theme);
    this.applyTheme(theme);
  }

  private applyTheme(theme: E_ThemeOption) {
    let themeToApply: E_ThemeOption;

    if (theme === E_ThemeOption.System) {
      themeToApply = window.matchMedia('(prefers-color-scheme: dark)').matches 
        ? E_ThemeOption.Dark 
        : E_ThemeOption.Light;
    } else {
      themeToApply = theme;
    }
    this.currentTheme.next(theme);

    document.documentElement.setAttribute('data-theme', themeToApply);
  }
}